const REDUX_OPTION = {
  /**
   * Used to validate certain changed keys.
   * @type {string}
   */
  KEYS_TO_VALIDATE: 'keysToValidate',

  /**
   * Keys to keep after saving data.
   * @type {string}
   */
  KEYS_TO_KEEP: 'keysToKeep',

  /**
   * If an action needs to be forced
   * @type {string}
   */
  IS_FORCED: 'isForced',

  /**
   * If an action can't be queued.
   * e.g. save request
   * @type {string}
   */
  IS_IMMEDIATE: 'isImmediate',

  SHOW_ERROR: 'showError',
  SHOULD_SAVE: 'shouldSave',

  /**
   * Ignore updatedAt param when loading items.
   * @type {string}
   */
  IGNORE_UPDATED_AT: 'ignoreUpdatedAt',

  /**
   * Randomises the domain list's order when loaded.
   * @type {string}
   */
  SHUFFLE_DOMAIN_LIST_DATA_ORDER: 'shuffleDomainListDataOrder',

  /**
   * Gets the last item's `id` for pagination.
   * @type {string}
   */
  GET_PAGINATION_LAST_ITEM_ID: 'getPaginationLastItemId',

  NO_AUTH_NEEDED: 'noAuthNeeded'
}

export default REDUX_OPTION
